module.exports = __webpack_public_path__ + "img/rope-cleaning-universal-studios.ed4dcbda.jpg";